import React from "react";
import PropTypes from "prop-types";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FormMenu } from "../../../../components/Buttons";
import ItemListManager from "../../../../components/ItemListManager";
import CertificateForm from "./CertificateForm";
import TablePageReport from "../../../../components/TablePageReport";
import { CoverText, TableEmptyMessage } from "../../../../components/Utils";

function CertificateListForm({
  forwardedRef,
  className,
  model,
  rows,
  disabled,
  onChange,
}) {
  const formRef = React.useRef(null);
  const [state, setState] = React.useState({
    items: (model || []).map((item, index) => ({ ...item, index })),
    first: 0,
  });

  const getModel = React.useCallback(() => {
    const { items } = state;
    // return items;
    const model = items.map((item) => {
      const {
        issuer,
        issuer_id,
        name,
        certificate_id,
        remark,
        intension_date,
      } = item;
      return {
        issuer,
        issuer_id,
        name,
        certificate_id,
        remark,
        intension_date,
      };
    });
    return model;
  }, [state]);

  React.useImperativeHandle(forwardedRef, () => ({
    getModel,
  }));

  const onSave = React.useCallback(
    (onHide) => {
      const currentModel = formRef.current.getModel();
      console.log(">> saving certification ...", currentModel);
      const { items } = state;
      if (
        currentModel.index !== undefined &&
        items[currentModel.index] !== undefined
      ) {
        items[currentModel.index] = currentModel;
      } else {
        currentModel.index = items.length;
        items.push(currentModel);
      }
      setState((prev) => ({ ...prev, items }));
      onHide && onHide();
    },
    [formRef, state],
  );

  const onDelete = React.useCallback(
    (selected) => {
      console.log(">> deleting certification from list", selected);
      const items = state.items.filter((_, i) => i !== selected.index);
      setState((prev) => ({ ...prev, items }));
      onChange && onChange(items);
    },
    [state, onChange],
  );

  const renderItemTable = React.useCallback(
    (items, actionTemplate) => {
      const data = items.map((item, index) => ({ ...item, index }));
      return (
        <div>
          <h4 className="no-margin alg-center pad-big-btm">
            {"Update für diesen Bereich erfolgt mit einer weiteren Version."}
          </h4>
          <DataTable
            value={data}
            rows={rows}
            paginator={data.length > rows}
            first={state.first}
            onPage={(event) =>
              setState((prev) => ({ ...prev, first: event.first }))
            }
            paginatorLeft={
              <TablePageReport
                className="pad-lft"
                totalRecords={data.length}
                filteredRecords={data.length}
                first={state.first}
                rows={rows}
                emptyText="Keine Zertifizierungen"
                itemName="Zertifizierung"
                itemNamePlural="Zertifizierungen"
              />
            }
            emptyMessage={
              <TableEmptyMessage itemNamePlural="Zertifizierungen" min />
            }
          >
            <Column
              field="issuer"
              header="Art"
              sortable={data.length > 1}
              filter={data.length > rows}
              filterMatchMode="contains"
            />
            <Column
              field="name"
              header="Zertifizierung"
              sortable={data.length > 1}
              filter={data.length > rows}
              filterMatchMode="contains"
            />
            {/* <Column field="remark" header="Nummer"/>  */}
            <Column
              field="intension_date"
              header="angemeldet"
              sortable={data.length > 1}
              filter={data.length > rows}
              filterMatchMode="contains"
              style={{ textAlign: "center", width: "10em" }}
            />
            <Column
              field="status"
              header="Status"
              sortable={data.length > 1}
              filter={data.length > rows}
              filterMatchMode="contains"
              style={{ textAlign: "center", width: "10em" }}
            />
            <Column
              body={actionTemplate}
              style={{ textAlign: "center", width: "7.4em" }}
            />
          </DataTable>
        </div>
      );
    },
    [state, rows],
  );

  const renderItemForm = React.useCallback(
    (item, onHide) => {
      const certification = item || {
        issuer: "",
        name: "",
        remark: "",
        intension_date: "",
        status: "",
      };
      return (
        <div>
          <CertificateForm
            key={Math.random()}
            ref={formRef}
            model={certification}
            disabled={disabled}
          />
          <FormMenu
            className="margin-big-top w3-border-top pad-big w3-light-grey"
            style={{
              marginLeft: "-1em",
              marginRight: "-1em",
              marginBottom: "-1em",
            }}
            onSave={() => onSave(onHide)}
            onCancel={onHide}
            saveBtnName="saveCertificateBtn"
            saveHidden
            cancelBtnLabel="Schließen"
          />
        </div>
      );
    },
    [disabled, onSave],
  );

  const getItemFormTitle = React.useCallback(
    (certification) => {
      // console.log('CertificationListForm.getItemFormTitle()', certification);
      // if (!certification) return 'Neue Zertifizierung hinzufügen';
      // return 'Zertifizierung bearbeiten';
      // return (<h3 className="no-margin">{`Zertifizierung ${/* !isEditable ? 'ansehen' :  */(certification ? 'bearbeiten' : 'hinzufügen')}`}</h3>);
      return <h3 className="no-margin">{`Zertifizierung ansehen`}</h3>;
    },
    [],
  );

  return (
    <div className={className}>
      <ItemListManager
        key={Math.random()}
        title={
          <h3 className="no-margin-top">
            Zertifizierungen / Kompetenznachweise
          </h3>
        }
        addBtnLabel="Hinzufügen"
        addBtnName="addWorkerCertificateBtn"
        addBtnHidden
        itemVisibleOnly
        items={state.items}
        getItemFormTitle={getItemFormTitle}
        renderItemTable={renderItemTable}
        renderItemForm={renderItemForm}
        namePrefix="certificate"
      />
    </div>
  );
}

CertificateListForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.array,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default React.forwardRef((props, ref) => {
  return <CertificateListForm {...props} forwardedRef={ref} />;
});

export function CertificationListPanel({
  className = "",
  model = [],
  rows = 10,
}) {
  const formRef = React.useRef(null);
  const [first, setFirst] = React.useState(0);

  const renderItemTable = React.useCallback(
    (items) => {
      if (items.length === 0) {
        return (
          <CoverText>
            {"Für Sie liegen noch keine Zertifizierungen vor"}
          </CoverText>
        );
      }
      const data = items.map((item, index) => ({ ...item, index }));
      return (
        <div>
          <h4 className="no-margin alg-center pad-big-btm">
            {"Update für diesen Bereich erfolgt mit einer weiteren Version."}
          </h4>
          <DataTable
            value={data}
            rows={rows}
            paginator={data.length > rows}
            first={first}
            onPage={(event) => setFirst(event.first)}
            paginatorLeft={
              <TablePageReport
                className="pad-lft"
                totalRecords={data.length}
                filteredRecords={data.length}
                first={first}
                rows={rows}
                emptyText="Keine Zertifizierungen"
                itemName="Zertifizierung"
                itemNamePlural="Zertifizierungen"
              />
            }
            emptyMessage={
              <TableEmptyMessage itemNamePlural="Zertifizierungen" min />
            }
          >
            <Column
              field="issuer"
              header="Art"
              sortable={data.length > 1}
              filter={data.length > rows}
              filterMatchMode="contains"
            />
            <Column
              field="name"
              header="Zertifizierung"
              sortable={data.length > 1}
              filter={data.length > rows}
              filterMatchMode="contains"
            />
            <Column
              field="registrationDate"
              header="angemeldet"
              sortable={data.length > 1}
              filter={data.length > rows}
              filterMatchMode="contains"
              style={{ textAlign: "center", width: "10em" }}
            />
            <Column
              field="status"
              header="Status"
              sortable={data.length > 1}
              filter={data.length > rows}
              filterMatchMode="contains"
              style={{ textAlign: "center", width: "10em" }}
            />
          </DataTable>
        </div>
      );
    },
    [first, rows],
  );

  const renderItemForm = React.useCallback((item, onHide) => {
    return (
      <div>
        <CertificateForm ref={formRef} model={item} readOnly />
        <FormMenu
          className="margin-big-top w3-border-top pad-big"
          style={{
            marginLeft: "-1em",
            marginRight: "-1em",
            marginBottom: "-1em",
          }}
          onCancel={onHide}
          saveDisabled
          saveBtnName="saveCertificateBtn"
          saveHidden
          cancelBtnLabel="Schließen"
        />
      </div>
    );
  }, []);

  const getItemFormTitle = React.useCallback(() => {
    return <h3 className="no-margin">{`Zertifizierung ansehen`}</h3>;
  }, []);

  return (
    <ItemListManager
      className={className}
      title={
        <h3 className="no-margin-top">Zertifizierungen / Kompetenznachweise</h3>
      }
      addBtnHidden
      itemVisibleOnly
      items={model}
      getItemFormTitle={getItemFormTitle}
      renderItemTable={renderItemTable}
      renderItemForm={renderItemForm}
      namePrefix="certificate"
    />
  );
}

CertificationListPanel.propTypes = {
  className: PropTypes.string,
  model: PropTypes.array,
  rows: PropTypes.number,
};
